import { render, staticRenderFns } from "./WsDragAndDropFile.vue?vue&type=template&id=787e4543"
import script from "./WsDragAndDropFile.vue?vue&type=script&lang=js"
export * from "./WsDragAndDropFile.vue?vue&type=script&lang=js"
import style0 from "./WsDragAndDropFile.vue?vue&type=style&index=0&id=787e4543&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports